import { useState, useLayoutEffect } from "react";

import { getWindowDimensions } from "../utils";

const useWindowDimensions = () => {
  const [windowDimensions, setWindowDimensions] = useState({
    width: 100,
    height: 100,
  });

  useLayoutEffect(() => {
    setWindowDimensions(getWindowDimensions());

    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
};

export default useWindowDimensions;
